module.exports = __webpack_public_path__ + "img/petstairs38.2cee886f.jpg";